const CreatureConfigFields = () => {
    return {
        spezies:true,
        mengenmeldung:false,
        meldeid:false,
        geschlecht:true,
        rufname:true,
        geburtsdatum:true,
        datumBesitzSeit:false,
        ring:false,
        microchip:false,
        andereKennzeichnung:false,
        zuchtbuch:false,
        fotodokumentation:false,
        dokumente:true,
        gewicht:true,
        groesse:true,
    }; 
}
export default CreatureConfigFields;